var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cms-editions"},_vm._l((_vm.cmsEditions),function(edition,key){return _c('cms-edition',{key:key,attrs:{"edition":edition}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }